import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useControlPlane } from '../../controlPlane/ControlPlaneProvider';
import { useOrg } from "../orgs/org-context";
import "./HomePage.css";
import HomeProjectsList from './HomeProjectsList';


export default function HomePage() {
  const { enabled, loading, error, retry } = useControlPlane();
  if (error) return <div className="home-page" role="alert"><p>{error}</p><button type="button" onClick={retry}>Retry</button></div>;
  if (loading || (enabled !== true && enabled !== false)) return <div className="home-page" role="status">Loading Dashboard...</div>;
  return enabled ? <ControlPlaneDashboard /> : <LegacyHomePage />;
}

function ControlPlaneDashboard() {
  const { activeOrg, activeOrgId } = useOrg();
  return <div className="home-page">
    <h1>EveryID Ops Dashboard</h1>
    <p>Your shared control plane for EveryID applications and platform services.</p>
    <p><strong>Selected organization: </strong>{activeOrg?.organization || activeOrgId || 'No organization selected'}</p>
    <section className="home-projects-card" style={{ minHeight: 'auto' }} aria-label="Applications launcher">
      <h2>Apps</h2>
      <p>Open Apps to see application availability for your selected organization.</p>
      <Link to="/apps" style={{ fontWeight: 700 }}>Go to Apps</Link>
    </section>
    <p><Link to="/reports">Reports</Link> — Platform reporting and diagnostics, coming later.</p>
  </div>;
}

function LegacyHomePage() {
  const navigate = useNavigate();
  const { activeOrg } = useOrg();
  console.log("activeOrg:", activeOrg)
  return (
    <div className="home-page">
      {/* Header
      <div className="home-header">
        <div className="home-org-name">
          {"Home Page"}
        </div>
        <div className="home-org">
          <div className="home-org-label">Active Organization</div>
          <div className="home-org-name">
            {activeOrg?.organization || "No organization selected"}
          </div>
        </div>
      </div> */}

      {/* Recent Projects */}

      <HomeProjectsList />

      {/* Sections */}

      <div
        className="home-sections"
        style={{
          marginTop: 40
        }}
      >
        <section>
          <h3>Design Tools</h3>
          <p className="section-subtitle">Design & configuration</p>
          <ul>
            <li onClick={() => navigate("/lpages")}>Landing Pages</li>
            <li onClick={() => navigate("/cards")}>Card Designs</li>
            <li onClick={() => navigate("/mediapage")}>Media Library</li>
            <li onClick={() => navigate("/templates/fieldtemplateList")}>Project Templates</li>
          </ul>
        </section>

        <section>
          <h3>Operations</h3>
          <p className="section-subtitle">Live data & fulfillment</p>
          <ul>
            <li onClick={() => navigate("/gallery/datasets")}>Live Gallery</li>
            <li onClick={() => navigate("/datasets/datadoclist")}>Data Records</li>
            <li onClick={() => navigate("/printers")}>Printers</li>
            <li onClick={() => navigate("/printergroups")}>Printer Groups</li>
          </ul>
        </section>

        <section>
          <h3>Applications</h3>
          <p className="section-subtitle">End-user experiences </p>
          <ul>
            <li onClick={() => navigate("/apps")}><strong>Apps</strong></li>
            <li onClick={() => navigate("/game")}>Games</li>
            <li onClick={() => navigate("/bureau-print")}>Bureau Print</li>
          </ul>
        </section>
      </div>
    </div>
  );
}
